'use client';

import { useIsDesktop } from '@/_hooks/useBreakpoint';

import SearchDesktop from './search.desktop';

const Search = () => {
  const isDesktop = useIsDesktop();

  if (isDesktop) {
    return <SearchDesktop />;
  }

  return null;
};

export default Search;
